import React, { useEffect } from "react";
import api from "../../../common/lib/api";
import Managed, { useManaged } from "../../../common/components/Managed";
import AsyncButton from "../../../common/components/AsyncButton";
import * as XLSX from "xlsx";
import moment from "moment";

const DEFAULT_STATE = [];

export default function Page({ system, period, companyId }) {
  const [state, setState, setError] = useManaged(DEFAULT_STATE);

  useEffect(() => {
    if (companyId) {
      (async () => {
        try {
          const { data } = await api.get(
            "/bill-data-report/" +
              system +
              "/times/" +
              period +
              "/companies/" +
              companyId +
              "/data"
          );
          setState(data);
        } catch (e) {
          setError(e);
        }
      })();
    }
  }, [period, companyId, setError, setState, system]);

  return (
    <Managed state={state}>
      <>
        <br />
        <AsyncButton
          onClick={async () => {
            const {
              data: { data },
            } = await api.get(
              `/bill-data-report/${system}/times/${period}/companies/${companyId}/export-data`
            );

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
              wb,
              XLSX.utils.json_to_sheet(data),
              `Billing Data Export for ${period}`
            );

            const binaryData = XLSX.write(wb, {
              bookType: "xlsx",
              bookSST: false,
              type: "binary",
            });

            const a = document.createElement("a");
            a.href = createDownloadUrl(binaryData);
            a.download = `${period}_${companyId}_Billing_Export_${moment().format(
              "YYYYMMDD_HHmmss"
            )}.xlsx`;
            a.click();
          }}
        >
          Download Data
        </AsyncButton>
        <table className="bp3-html-table">
          <tbody>
            {state.data.map((typeItems) => {
              const [description, devices] = typeItems;
              return (
                <tr>
                  <th>{description}</th>
                  <td>{devices.length}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {state.data.map((typeItems) => {
          const [description, devices] = typeItems;
          return (
            <>
              <h4>{description}</h4>
              <p>{devices.join(" ")}</p>
            </>
          );
        })}
      </>
    </Managed>
  );
}

export function createDownloadUrl(binaryData) {
  const arrayBuffer = new ArrayBuffer(binaryData.length);
  const view = new Uint8Array(arrayBuffer);
  for (let i = 0; i < binaryData.length; i += 1) {
    // eslint-disable-next-line
    view[i] = binaryData.charCodeAt(i) & 0xff;
  }
  let blob;
  try {
    // This is the recommended method.
    blob = new Blob([arrayBuffer], { type: "application/octet-stream" });
  } catch (e) {
    // The BlobBuilder API has been deprecated in favour of Blob, but older
    // browsers don't know about the Blob constructor
    // IE10 also supports BlobBuilder, but since the `Blob` constructor
    // also works, there's no need to add `MSBlobBuilder`.
    const bb = new (window.WebKitBlobBuilder || window.MozBlobBuilder)();
    bb.append(arrayBuffer);
    blob = bb.getBlob("application/octet-stream"); // <-- Here's the Blob
  }
  const url = (window.webkitURL || window.URL).createObjectURL(blob);
  return url;
}
